<template>
  <!-- 全站注入 Ant Design Vue 主题（antTheme）与中文 locale，统一视觉与文案 -->
  <a-config-provider
    :theme="antTheme"
    :locale="zhCN"
  >
    <RouterView />
  </a-config-provider>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
// 中文语言包，统一 Ant 组件内置文案（分页、日期、空状态等）
import zhCN from 'ant-design-vue/es/locale/zh_CN';
// 全站主题配置（任务 1 产出），集中管理 token 与组件级样式
import { antTheme } from '@/theme/ant-theme';
</script>
